export const LYSAGHT_POAs = ["MASTER", "LSB", "DAR", "EMU", "NUN", "LAU", "GIL", "KEW"];
export const CENTENARY_POAs = ["MASTER", "MEN", "CAM", "MIN", "WAN"];